
import styled from 'styled-components';

export const MarginLayout = styled.div`
  margin-right: 12.5px !important;
  margin-left: 7.5px !important;
`;
